import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { messages as m } from '../../../constants';
import * as D from '../../../deps';
import { getPodcastProgramDetailsById } from '../../../utils';
import BackstagePodcastEpisodeListItem from '../../common/BackstagePodcastEpisodeListItem';

const integrationData = {
  contentSection: D.Constants.ContentSections.BackstageContentSections.METADATA_CONTINUE,
};
const ContinueListeningRowItemWithLogger = D.withVisibilityLogger(integrationData)(
  BackstagePodcastEpisodeListItem,
);

export const BackstagePodcastProgramContinueListening = props => {
  if (!props.continueListeningEpisodeId || props.isMobileDevice) return null;
  return (
    <D.Utils.Context.AppContextIntegrationData data={integrationData}>
      <D.ContentSection title={<FormattedMessage {...m.continueListening} />}>
        <ContinueListeningRowItemWithLogger
          pandoraId={props.continueListeningEpisodeId}
          hasBorderTopBottom={true}
        />
      </D.ContentSection>
    </D.Utils.Context.AppContextIntegrationData>
  );
};

BackstagePodcastProgramContinueListening.propTypes = {
  programId: PropTypes.string.isRequired,
  continueListeningEpisodeId: PropTypes.string,
  isMobileDevice: PropTypes.bool,
};

export function mapStateToProps(state, ownProps) {
  const userProgramDetails = getPodcastProgramDetailsById(state, ownProps.programId);

  return {
    continueListeningEpisodeId: userProgramDetails.get('continueListeningEpisode'),
    isMobileDevice: D.isMobileDevice(state),
  };
}

export default connect(mapStateToProps)(BackstagePodcastProgramContinueListening);
